"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { SORT_OPTIONS, type SortValue, type TourQuery } from "../filters";
import { listingHref, type ListingNav } from "../listing-url";
import type { FilterTexts } from "./filter-form";
import { Select } from "@/components/ui/form-field";
import { buttonClass } from "@/components/ui/button";

// Sıralama değişince sayfa 1'e dönülür, filtreler korunur. JavaScript yoksa "Sırala" düğmesiyle GET form. Filtre sayfasında
// (/avrupa-turlari) adres aynı sayfada kalır: /avrupa-turlari?sirala=fiyat-artan (listing-url.ts).
export function SortSelect({ nav, t, query }: { nav: ListingNav; t: FilterTexts; query: TourQuery }) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  const [action, qs = ""] = listingHref({ ...query, sirala: "tarih", sayfa: 1 }, nav).split("?");
  const hidden = Object.entries(Object.fromEntries(new URLSearchParams(qs)));

  return (
    <form action={action} method="get" className="flex items-center gap-2" aria-busy={pending}>
      {hidden.map(([k, v]) => (
        <input key={k} type="hidden" name={k} value={v} />
      ))}
      <label htmlFor="sirala" className="sr-only text-sm font-medium whitespace-nowrap text-ink-muted sm:not-sr-only">
        {t.sortLabel}
      </label>
      <Select
        id="sirala"
        name="sirala"
        defaultValue={query.sirala}
        onChange={(e) => {
          const next = e.currentTarget.value as SortValue;
          startTransition(() => router.push(listingHref({ ...query, sirala: next, sayfa: 1 }, nav), { scroll: false }));
        }}
        className="h-11 text-sm font-semibold"
      >
        {SORT_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {t.sort[o.value]}
          </option>
        ))}
      </Select>
      <noscript>
        <button type="submit" className={buttonClass("primary", "sm")}>
          {t.sortSubmit}
        </button>
      </noscript>
    </form>
  );
}
